<template>
  <v-navigation-drawer
    :value="showDrawer"
    temporary
    fixed
    right
    width="500"
    :disable-route-watcher="true"
    stateless
  >
    <template v-slot:prepend>
      <v-list-item two-line>
        <v-list-item-content>
          <v-list-item-title ref="titolo" class="text-h6">{{drawerTitle}}</v-list-item-title>
          <v-list-item-subtitle>{{drawerSubtitle}}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template>
    <v-divider></v-divider>
    <v-form ref="form" v-model="formFieldsValid" lazy-validation>
      <v-list dense>
        <v-list-item
          v-for="item in movimentoItems"
          :key="item.label"
        >
          <v-list-item-content>
            <v-list-item-title>
              <component :is="'p' + item.type" :item="item" :appoggio="locMovimento.appoggio" @change="componentValueChange" :disabled="readOnly"/>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-form>
    <template v-slot:append>
      <v-container fluid>
        <v-row align="center">
          <v-col class="d-flex justify-space-around" cols="12" sm="6" v-if="!readOnly">
            <v-badge bordered color="error" icon="mdi-lock" title="Verificare i dati inseriti" overlap :value="!formFieldsValid">
              <v-btn color="success mb-2" @click="onSalva" :disabled="!formFieldsValid">Salva</v-btn>
            </v-badge>
          </v-col>
          <v-col class="d-flex justify-space-around" cols="12" sm="6">
            <v-btn color="secondary mb-s" @click="onAnnulla" >{{annullaTitle}}</v-btn>
          </v-col>
        </v-row>
      </v-container>
      <dialog-conferma
        :show="dialogConferma"
        :title="titoloConferma"
        :message="messaggioConferma"
        @dialog-confirm="onConferma"
        @dialog-cancel="dialogConferma=false"
      />
    </template>
  </v-navigation-drawer>
</template>

<script>
import * as dot from 'dot-object'
import _ from 'lodash'
import configurazioni from '@/services/configurazioniService.js'
import DialogConferma from '@/components/dialogConferma'

import pTesto from '@/views/drawer/elementi/testo'
import pMultiselect from '@/views/drawer/elementi/multiselect'
import pData from '@/views/drawer/elementi/data'
import pProdotto from '@/views/drawer/elementi/prodotto'
import pClifor from '@/views/drawer/elementi/clifor'
import pDestinazioni from '@/views/drawer/elementi/destinazioni'

export default {
  components: {
    DialogConferma,
    pTesto,
    pMultiselect,
    pData,
    pProdotto,
    pClifor,
    pDestinazioni
  },
  data: (vm) => ({
    backoffice: null,
    show: false,
    locMovimento: null,
    formFieldsValid: true,
    dialogConferma: false,
    titoloConferma: '',
    messaggioConferma: '',
    onConferma: vm.modificaPrezzoAcquisto
  }),
  async mounted() {
    this.backoffice = await configurazioni.getConfigurazione('backoffice', 'pagine')
    this.locMovimento = this.$store.getters['movimenti/movimento'] || null
    if (this.nuovoArticoloCreato) {
      this.locMovimento.prodotto = { codice: this.nuovoArticoloCreato._id }
      this.locMovimento.appoggio = this.locMovimento.appoggio || {}
      this.locMovimento.appoggio.prodotto = this.nuovoArticoloCreato
      this.locMovimento.appoggio.prodotto.acquisto = this.locMovimento.appoggio.prodotto.magazzino.prezzoAcquisto || 0
      this.locMovimento.appoggio.prodotto.prezzo = this.locMovimento.appoggio.prodotto.prezzo.L1.base || 0
      this.$store.commit('movimenti/SET_ARTICOLO_CREATO', null)
    }
    if (this.nuovoCliforCreato) {
      if (this.locMovimento.appoggio.clienteVisibile) { // verificare tutto
        this.locMovimento.anagrafica.cliente = { codice: this.nuovoCliforCreato._id }
        this.locMovimento.appoggio = this.locMovimento.appoggio || {}
        this.locMovimento.appoggio.cliente = this.nuovoCliforCreato
      } else if (this.locMovimento.appoggio.fornitoreVisibile) {
        this.locMovimento.anagrafica.fornitore = { codice: this.nuovoCliforCreato._id }
        this.locMovimento.appoggio = this.locMovimento.appoggio || {}
        this.locMovimento.appoggio.fornitore = this.nuovoCliforCreato
      }
      this.$store.commit('clienti/SET_CLIFOR_CREATO', null)
    }
  },
  watch: {
    movimento(value) {
      this.locMovimento = value
    }
  },
  computed: {
    showDrawer() {
      return this.$store.getters.rightDrawer
    },
    readOnly() {
      return this.$store.getters.rightDrawerReadOnly
    },
    drawerTitle() {
      if (this.readOnly) {
        return 'Visualizza movimento'
      } else {
        return this.locMovimento && this.locMovimento._id ? 'Modifica movimento' : 'Nuovo movimento'
      }
    },
    drawerSubtitle() {
      return this.locMovimento ? `${this.locMovimento.causale} - ${this.locMovimento.prodotto.codice}` : ''
    },
    annullaTitle() {
      return this.readOnly ? 'Chiudi' : 'Annulla'
    },
    movimento() {
      return this.$store.getters['movimenti/movimento'] || null // || { codice: '', descrizione: '' }
    },
    movimentoItems() {
      if (!this.locMovimento || !this.backoffice) {
        return []
      }
      const vars = this.backoffice.movimenti
      const items = []
      // item.subModel, --> usato per marchio, tipoItem tipoBene : Da categorie leggo codice, descrizione ma devo salvare solo descrizione o solo codice
      for (const item of vars) {
        items.push({value: dot.pick(item.valueField, this.locMovimento), ...item})
      }
      return items
    },
    nuovoArticoloCreato() {
      var na = this.$store.getters['movimenti/articoloCreato'] || null
      return na
    },
    nuovoCliforCreato() {
      var na = this.$store.getters['clienti/cliforCreato'] || null
      return na
    }    
  },
  methods: {
    async componentValueChange(data) {
      const { model, subModel, value, decimals } = data
      let tgt = {}
      if (subModel) {
        let vv = value[subModel]
        if (decimals >= 0) {s
          vv = +parseFloat(vv).toFixed(decimals)
        }
        dot.str(model, vv, tgt)
      } else {
        let vv = value
        if (decimals >= 0) {
          vv = +parseFloat(vv).toFixed(decimals)
        }
        dot.str(model, vv, tgt)
      }
      _.merge(this.locMovimento, tgt)
      await this.aggiornaCorrelati(data)
    },
    async aggiornaCorrelati(data) {
      this.locMovimento.appoggio = this.locMovimento.appoggio || {}
      switch (data.model) {
/*         case 'anagrafica.fornitore':
        case 'anagrafica.cliente':
          let a = this.locMovimento.appoggio.anagrafica
          // this.locMovimento.appoggio.anagrafica = data.value.codice
          break; */
        case 'causale':
          this.locMovimento.appoggio.causale = data.value
          this.locMovimento.appoggio.clienteVisibile = data.value.visualizzaCliente
          this.locMovimento.appoggio.fornitoreVisibile = data.value.visualizzaFornitore
          break;
        case 'prodotto.codice':
          this.locMovimento.appoggio.prodotto = data.item
          this.locMovimento.prodotto.prezzoUnitario = data.item.prezzo
          break;
        case 'quantita':
          const valore = isNaN(data.value) ? 0 : parseFloat(data.value)
          this.locMovimento.quantita = +valore.toFixed(2)
          const pr = this.locMovimento.appoggio.prodotto
          if (pr && this.locMovimento.appoggio.causale) {
            let valoreItem = this.locMovimento.appoggio.causale.tipoPrezzo === 'acquisto' ? pr.acquisto : pr.prezzo
            this.locMovimento.valore = +(valoreItem * valore).toFixed(2)
            this.locMovimento.appoggio.valoreCalcolato = this.locMovimento.valore
          }
          break;
          case 'valoreUnitario': // TODO: Completare ed aggiungere il campo su db e valoreUnitario
          if (this.locMovimento.valoreUnitario) {
            let ma = this.locMovimento.appoggio
            const valore = isNaN(data.value) ? 0 : parseFloat(data.value) 
            this.locMovimento.valoreUnitario = +valore.toFixed(2)
            if (this.locMovimento.valoreUnitario !== this.locMovimento.appoggio.valoreUnitario) {
              if(ma.causale.aggiornaPrezzoAcquisto) {
                this.titoloConferma = "Valore acquisto modificato"
                this.messaggioConferma = 'Confermi aggiornamento prezzo di acquisto ?'
                this.dialogConferma = true
                this.onConferma = this.modificaPrezzoAcquisto(true)
              }
              if(ma.causale.aggiornaPrezzoVendita) {
                this.locMovimento.prodotto.prezzoUnitario = this.locMovimento.valoreUnitario // verificare
                this.titoloConferma = "Valore vendita modificato"
                this.messaggioConferma = 'Confermi aggiornamento prezzo di vendita ?'
                this.dialogConferma = true
                this.onConferma = this.modificaPrezzoVendita(true)
              }
            }
            
          }
          break;
        case 'valore':
          if (this.locMovimento.valore) {
            let ma = this.locMovimento.appoggio
            const valore = isNaN(data.value) ? 0 : parseFloat(data.value) 
            //this.locMovimento.valore = +parseFloat(this.locMovimento.valore).toFixed(2)
            this.locMovimento.valore = +valore.toFixed(2)
            if (this.locMovimento.valore !== this.locMovimento.appoggio.valoreCalcolato) {
              // TODO: richiesta di aggiornamento prezzo di acquisto o di vendita in base a causale
              if(ma.causale.aggiornaPrezzoAcquisto) {
                this.titoloConferma = "Valore acquisto modificato"
                this.messaggioConferma = 'Confermi aggiornamento prezzo di acquisto ?'
                this.dialogConferma = true
                this.onConferma = this.modificaPrezzoAcquisto(false)
              }
              if(ma.causale.aggiornaPrezzoVendita) {
                this.titoloConferma = "Valore vendita modificato"
                this.messaggioConferma = 'Confermi aggiornamento prezzo di vendita ?'
                this.dialogConferma = true
                this.onConferma = this.modificaPrezzoVendita(false)
              }
            }
          }
          break;
  /*       case 'datiFiscali.reparto': // TODO: Sistemare. Verificare come passare CodiceStampante oppure togliere campi in più sugli altri elenenti. Vedi mounted su multiselect
          let reparto = {
            codice: this.locMovimento.datiFiscali.reparto.codice,
            descrizione: this.locMovimento.datiFiscali.reparto.descrizione,
            stampante: this.locMovimento.datiFiscali.reparto.stampante.numero
          }
          this.locMovimento.datiFiscali = {}
          this.locMovimento.datiFiscali.reparto = reparto
          try {
            const cnfReparti = await configurazioni.getConfigurazione('prodotti_reparti_fiscali', 'reparti')
            const rf = cnfReparti.find (x => x.codice === this.locMovimento.datiFiscali.reparto.codice)

            const cnfIva = await configurazioni.getConfigurazione('prodotti_aliquote_iva', 'aliquote')
            const ai = cnfIva.find (x => x.codice === rf.codiceIva)
            let aliquotaIva = {
              codice: ai.codice,
              valore: ai.aliquota,
              descrizione: ai.descrizione,
              tipoApplicazione: 'banco' // TODO: andrà inserita la possibilità di scegliere più tipi iva in base al tipoApplicazione. Forse nel reparto
            }
            this.locMovimento.datiFiscali.aliquoteIva = []
            this.locMovimento.datiFiscali.aliquoteIva.push(aliquotaIva)
          } catch(error) {
            console.log('errore aggiornamento reparto fiscale:', error)
          }
          break
        case 'ricercaBarcode':
          const adesso = new Date()
          let newBarcode = {
            codice: this.locMovimento.ricercaBarcode,
            da: adesso,
            attivo: true
          };
          if (!this.locMovimento.barcode || this.locMovimento.barcode.length === 0) {
            this.locMovimento.barcode = []
          } else {
            for (let el of this.locMovimento.barcode) {
              if (el.attivo) {
                el.attivo = false
                el.a = adesso
              }
            }
          }
          //this.locMovimento.barcode.push(newBarcode)
          this.$set(this.locMovimento.barcode, this.locMovimento.barcode.length || 0, newBarcode)
          break;
        case 'prezzo.L2.base':
          this.locMovimento.prezzo.L2.base = +parseFloat(data.value).toFixed(2)
          break
        case 'prezzo.L1.base':
          this.locMovimento.prezzo.L1.base = +parseFloat(data.value).toFixed(2)
          break
        case 'magazzino.prezzoAcquisto':
          this.locMovimento.magazzino.prezzoAcquisto = +parseFloat(data.value).toFixed(2)
          this.locMovimento.magazzino.valore = +(this.locMovimento.magazzino.giacenza * this.locMovimento.magazzino.prezzoAcquisto).toFixed(2)
          break
        case 'magazzino.giacenza':
          this.locMovimento.magazzino.giacenza = +parseFloat(data.value).toFixed(2)
          this.locMovimento.magazzino.valore = +(this.locMovimento.magazzino.giacenza * this.locMovimento.magazzino.prezzoAcquisto).toFixed(2)
          break */
        default:
          break
      } 
    },
    modificaPrezzoAcquisto(unitario) {
      console.log('Modifica prezzo acquisto')
      if (unitario) {

      } else {

      }
    },
    modificaPrezzoVendita(unitario) {
      console.log('Modifica prezzo vendita')
      if (unitario) {

      } else {
        
      }
    },
    onAnnulla() {
      this.$refs.form.reset()
      this.$store.commit('SET_RIGHT_DRAWER', false)
      this.$store.commit('movimenti/SET_REFRESH')
      this.$store.commit('movimenti/CLEAR_MOVIMENTO')
    },
    onSalva() {
      const valid = this.$refs.form.validate()
      if (valid) {
        // TODO: eliminare i campi di appoggio creati per la gestione dell'interfaccia
        this.$store.commit('movimenti/SET_MOVIMENTO', this.locMovimento)
        this.$store.commit('movimenti/SET_MOVIMENTO_SAVED')
      }
    }
  }
}
</script>